export function getCopiedEnvelopeId(response) {
  const data = response?.data || response || {};
  return (
    data.envelope_id ||
    data.id ||
    data.envelope?.id ||
    data.envelope?.envelope_id ||
    data.data?.envelope_id ||
    data.data?.id ||
    data.data?.envelope?.id ||
    data.data?.envelope?.envelope_id ||
    null
  );
}
